/**
 * Global Menu
 */

export function global_menu() {
  (function(){
    const nav = document.getElementById('header-global-nav');
    if (!nav) return;

    const items = nav.querySelectorAll('li[data-has="has-submenu"]');

    function positionSubmenu(li){
      const submenu = li.querySelector(':scope > .p-submenu');
      if (!submenu) return;

      // いったんリセット（左寄せ基準）
      submenu.style.left = '0';
      submenu.style.right = 'auto';
      submenu.style.transformOrigin = 'top left';

      const rect = submenu.getBoundingClientRect();
      const vw = document.documentElement.clientWidth;

      // 右がはみ出すなら、右寄せに切り替え
      if (rect.right > vw - 8) {
        submenu.style.left = 'auto';
        submenu.style.right = '0';
        submenu.style.transformOrigin = 'top right';
      }

      // それでも左がはみ出すなら、画面内に収める
      const rect2 = submenu.getBoundingClientRect();
      if (rect2.left < 8) {
        const shift = 8 - rect2.left;

        // left 寄せのままなら left を押し込む
        if (submenu.style.left !== 'auto') {
          submenu.style.left = shift + 'px';
        }

        // right 寄せなら right を増やして左へ
        if (submenu.style.right !== 'auto') {
          const currentRight = parseFloat(getComputedStyle(submenu).right) || 0;
          submenu.style.right = (currentRight + shift) + 'px';
        }
      }
    }

    // ★ 追加：開閉状態をJSで統一管理（.is-select 付与）
    function setSelect(li, on){
      li.classList.toggle('is-select', !!on);
    }

    items.forEach(li => {
      // hoverで開いた瞬間
      li.addEventListener('mouseenter', () => {
        setSelect(li, true);
        positionSubmenu(li);
      });

      // hoverで閉じた瞬間
      li.addEventListener('mouseleave', () => {
        setSelect(li, false);
      });

      // キーボードで入ってきた瞬間
      li.addEventListener('focusin', () => {
        setSelect(li, true);
        positionSubmenu(li);
      });

      // キーボードで外に出た瞬間
      li.addEventListener('focusout', (e) => {
        // liの外へフォーカスが移動したら閉じる
        if (!li.contains(e.relatedTarget)) {
          setSelect(li, false);
        }
      });

      // 「メニューを閉じる」クリックで閉じる
      const close = li.querySelector('.p-submenu .close');
      if (close) {
        close.addEventListener('click', () => {
          setSelect(li, false);
          close.blur();
          li.querySelector(':scope > a, :scope > span')?.focus?.();
        });
      }
    });

    // リサイズ時：開いてる（=is-select）ものだけ再計測
    window.addEventListener('resize', () => {
      items.forEach(li => {
        if (li.classList.contains('is-select')) positionSubmenu(li);
      });
    }, {passive:true});
  })();
}


// カレント処理
export function global_menu_current() {
  document.addEventListener('DOMContentLoaded', function () {
    // 現在のページのパスを取得し、配列に分割
    var pageURL = location.pathname;
    var pageURLArr = pageURL.split('/'); // パスを分割して配列化
    var pageURLArrCategory = pageURLArr[1]; // パスから第1階層を取得

    // カテゴリとクラス名の対応表
    var categoryToClassMap = {
      'personal'           : 'nav-personal',
      'business'           : 'nav-business',
      'repair-sales'       : 'nav-repair-sales',
      'advantages-city-gas': 'nav-advantages-city-gas',
      'about'              : 'nav-about',
      'contact'            : 'nav-contact'
    };

    // 対応するクラス名を取得
    var targetClass = categoryToClassMap[pageURLArrCategory];

    if (targetClass) {
      // 対応するクラスを持つspanにis-currentを追加
      var targetSpan = document.querySelector('.p-global-nav > ul > li.' + targetClass);
      if (targetSpan) {
        targetSpan.classList.add('is-current');
      }
    }
  });
}
